import { useSelector } from 'react-redux';

const useCompareConceptsOptions = (selectedConcept) => {
  const concepts = useSelector((state) => state.resonance.concepts);

  if (!selectedConcept?.value) {
    return [];
  }

  return concepts
    .filter((concept) => concept.id !== selectedConcept.value)
    .map((concept) => ({
      label: concept.name,
      value: concept.id,
    }));
};

export default useCompareConceptsOptions;
